<template>
	<div class="page flex-column">
		<div class="head flex-center">
			<div class="welcome flex-center">欢迎登录系统！今天是星期{{week[new Date().getDay()]}}</div>
			<div class="date flex-center">数据更新：{{date}}</div>
			<h1>永利带业售后工单大数据</h1>
		</div>
		<div class="body flex-between flex-grow">
			<div class="body-col flex-column">
				<module title="近30天售后绩效榜">
					<performance ref="m1"></performance>
				</module>
				<module title="售后服务地区TOP" style="flex-grow: 1.8;">
					<region ref="m2"></region>
				</module>
			</div>
			<div class="body-main flex-grow">
				<div class="total flex-center">
					<div class="total-item flex-center">
						<p>本月完成工单</p>
						<ul class="flex">
							<li v-for="(item, i) in totalData.completed_month" :key="i" class="flex-center"><span>{{item}}</span></li>
						</ul>
					</div>
					<div class="total-item flex-center">
						<p>当前未完成工单</p>
						<ul class="flex">
							<li v-for="(item, i) in totalData.unfinished" :key="i" class="flex-center"><span>{{item}}</span></li>
						</ul>
					</div>
				</div>
				<ul class="tab flex" :class="[`z-tab-${currentMapTab}`]">
					<li :class="{'z-crt': currentMapTab == 1}" @click="updateMap(1)">进行中的工单({{mapTotal[0]}})</li>
					<li :class="{'z-crt': currentMapTab == 2}" @click="updateMap(2)">未开始工单({{mapTotal[1]}})</li>
				</ul>
				<div class="map">
					<img src="@/assets/image/digital/map.png" alt="">
					
					<div v-for="(item, i) in regionList" :key="i" class="item" :style="{'z-index': targetRegion == item.index ? 1 : 0, 'left': `${item.coor[0]}%`, 'top': `${item.coor[1]}%`}" @mouseenter="targetRegion = item.index">
						<div class="light" :style="{'animation-delay': `${-item.index * 0.15}s`}"></div>
						<div class="point"></div>
						<div class="content" :class="{'z-active': targetRegion == item.index}">
							<img class="icon" src="@/assets/image/digital/map_icon.png" alt="">
							<div class="data flex-column flex-center-main">
								<h5>{{item.province_name}}</h5>
								<template v-if="currentMapTab == 1">
									<p>现场人员：{{item.field_staff}}人</p>
									<p>进行中的工单：{{item.count}}单</p>
								</template>
								<template v-else>
                                    <p>派工人数：{{item.field_staff}}人</p>
									<p>未开始工单：{{item.count}}单</p>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="body-col flex-column">
				<module title="工单实时分析">
					<work ref="m3"></work>
				</module>
				<module title="客户评价分析">
					<appraise ref="m4"></appraise>
				</module>
				<module title="售后网点满意度">
					<outlet ref="m5"></outlet>
				</module>
			</div>
		</div>
		
		<img class="foot" src="@/assets/image/digital/foot_line.png">
	</div>
</template>

<script>
	import module from './components/digital_module.vue'
	import performance from './components/performance.vue'
	import region from './components/region.vue'
	import work from './components/work.vue'
	import appraise from './components/appraise.vue'
	import outlet from './components/outlet.vue'
	import {createStore, mapStore} from './components/store.js'
	
	function throttle(fun, timer = 100, options) {
		options = Object.assign({
			immediate: true,
			trailing: true
		}, typeof options == 'boolean' ? {
			trailing: options
		} : options);

		let timeout, context, args;
		let previous = 0;

		const later = () => {
			previous = options.immediate === false ? 0 : Date.now();
			timeout = null;
			fun.apply(context, args);
			if (!timeout) context = args = null;
		};

		return function(...params) {
			const now = Date.now();
			if (!previous && options.immediate === false) previous = now;

			const remaining = timer - (now - previous);
			context = this;
			args = params;
			if (remaining <= 0 || remaining > timer) {
				if (timeout) {
					clearTimeout(timeout);
					timeout = null;
				}
				previous = now;
				fun.apply(context, args);
				if (!timeout) context = args = null;
			} else if (!timeout && options.trailing !== false) {
				timeout = setTimeout(later, remaining);
			}
		};
	}

	export default {
		components: {
			module,
			performance,
			region,
			work,
			appraise,
			outlet
		},

		data() {
			return {
				digitalStore: createStore({
					px(n) {
						return n * 0.00052083 * window.innerWidth;
					},
					registerChart: obj => {
						this.charts.push(obj);
					},
					processRateScale: 1
				}),
				week: {
					0: '日',
					1: '一',
					2: '二',
					3: '三',
					4: '四',
					5: '五',
					6: '六'
				},
				date: '',
				charts: [],
				
				totalData: {
					unfinished: [0],
					completed_month: [0]
				},
				currentMapTab: '',
				regionCoor: {
					'北京市': [59.2, 38],
					'浙江省': [64, 61],
					'天津市': [60, 40],
					'广东省': [56.5, 75],
					'上海市': [65.2, 57.6],
					'宁夏回族自治区': [49, 42],
					'福建省': [62, 69],
					'吉林省': [67.5, 33],
					'贵州省': [49, 66],
					'四川省': [45, 56],
					'青海省': [38, 44],
					'西藏自治区': [33, 54.5],
					'陕西省': [51, 50],
					'河南省': [57, 50],
					'香港特别行政区': [57, 80],
					'云南省': [41, 70],
					'内蒙古自治区': [53, 35],
					'安徽省': [60.5, 54],
					'重庆市': [50, 58],
					'江西省': [59, 64],
					'湖北省': [54.5, 56],
					'辽宁省': [65, 36],
					'新疆维吾尔自治区': [34, 34],
					'山西省': [55, 42],
					'江苏省': [63, 52],
					'海南省': [51, 87],
					'台湾省': [65.5, 76],
					'河北省': [58, 41],
					'广西壮族自治区': [50, 74],
					'黑龙江省': [68, 26],
					'甘肃省': [47, 45],
					'湖南省': [54, 63],
					'澳门特别行政区': [55, 80.8],
					'山东省': [61, 45]
				},
				mapTotal: [0, 0],
				regionList: [],
				targetRegion: -1
			}
		},

		computed: {
			...mapStore('digitalStore', ['px'])
		},
		
		watch: {
			targetRegion(val) {
				clearTimeout(this._mapTimer);
				this._mapTimer = setTimeout(() => {
					if (val == this.regionList.length - 1) {
						this.updateMap(this.currentMapTab == 1 ? 2 : 1);
					} else {
						this.targetRegion = this.regionList.find(item => item.index == val + 1).index;
					}
				}, 5000);
			}
		},

		mounted() {
			this.update();
			this.updateMap();
			this.digitalStore.commit('processRateScale', this.px(40) / 70);
			window.addEventListener('resize', throttle(() => {
				this.charts.forEach(item => {
					item.resize();
				});
				this.digitalStore.commit('processRateScale', this.px(40) / 70);
			}, 500));
		},
		
		methods: {
			update() {
				this.request({
					url: '/visual/data/kpi',
					success: data => {
						['unfinished', 'completed_month'].forEach(item => {
							let start = parseInt(this.totalData[item].join(''));
							let max = parseFloat(data.kpis[item]);
							let dir = start < max ? 1 : -1;
							max = Math.abs(parseFloat(max - start));
							let num = 0, gradient = max / 40;
							
							!function loop() {
								if (num < max) {
									num += gradient;
									if (num > max) {
										num = max;
									}
									this.totalData[item] = parseFloat(parseFloat(start + dir*num).toFixed(0)).toString().split('');
									setTimeout(loop.bind(this), 20);
								}
							}.call(this);
						});
					}
				});
				
				['m1', 'm2', 'm3', 'm4', 'm5'].forEach(item => {
					this.$refs[item].update();
				});
				
				setTimeout(this.update, 60000);
				this.date = new Date().format('yyyy年MM月dd日 hh:mm');
			},
			
			async updateMap(tab = 1) {
				if (this.currentMapTab == tab || this._currentMapTab == tab) return;
				this._currentMapTab = tab;
				if (this.targetRegion != -1) {
					this.targetRegion = -1;
					await new Promise(resolve => setTimeout(resolve, 1500));
				}
				this.currentMapTab = tab;
				this.regionList = [];
				this.request({
					url: '/visual/data/province_map',
					success: data => {
						let list = data[this.currentMapTab == 1 ? 'ongoing_list' : 'not_started_list'].map(item => {
							item.coor = this.regionCoor[item.province_name];
							return item;
						}).filter(item => item.coor);
						let index = new Array(list.length).fill('').map((item, index) => index);
						this.regionList = list.map(item => {
							let i = getRandomInt(0, index.length - 1);
							item.index = index[i];
							index.splice(i, 1);
							return item;
						});
						this.mapTotal = [data.ongoing_total, data.not_started_total]
						this.targetRegion = 0;
						delete this._currentMapTab;
						
						function getRandomInt(min, max) {
							min = Math.ceil(min);
							max = Math.floor(max);
							return Math.floor(Math.random() * (max - min + 1)) + min;
						}
					}
				});
			}
		}
	}
</script>

<style lang="stylus">
	html {
		font-size: 5.2083vw;
	}
</style>

<style lang="stylus" scoped>
	@font-face {
	    font-family: 'digital';
	    src: url('~@/assets/image/digital/DingTalk-JinBuTi.ttf') format('truetype');
	}
	
	.page {
		box-sizing: border-box;
		height: 100vh;
		overflow: hidden;
		font-family: 'digital';
		background-color: #000;
		background-image: url('~@/assets/image/digital/bg.jpg');
		background-size: 100% 100%;
		background-position: center;
		background-repeat: no-repeat;
		user-select: none;

		.head {
			z-index: 1;
			position: relative;
			height: .72rem;
			margin-bottom: .22rem;
			background-image: url('~@/assets/image/digital/head.png');
			background-size: auto 100%;
			background-position: center;
			
			&:after {
				content: '';
				position: absolute;
				left: 0;
				top: 0;
				width: .5rem;
				height: .02rem;
				background-image: url('~@/assets/image/digital/an_head.png');
				background-size: 100%;
				animation: headMove 5s infinite linear;
			
				@keyframes headMove {
					0% {
						opacity: 0;
						transform: translate(0,0);
					}
					10% {
						opacity: 1;
					}
					70% {
						opacity: 1;
					}
					80% {
						opacity: 0;
						transform: translate(100vw,0);
					}
					100% {
						opacity: 0;
						transform: translate(100vw,0);
					}
				}
			}

			h1 {
				padding-bottom: .05rem;
				font-size: .36rem;
				font-weight: normal;
				color: transparent;
				background: linear-gradient(0deg, #75DAFF 0%, #FFFFFF 100%);
				background-clip: text;
			}

			.welcome {
				position: absolute;
				top: .16rem;
				left: 1rem;
				font-size: .13rem;
				color: #02F4FF;
			}

			.date {
				position: absolute;
				top: .16rem;
				right: 1rem;
				font-size: .13rem;
				color: #02F4FF;
			}
		}

		.body {
			padding: 0 .25rem;

			&-col {
				z-index: 1;
				position: relative;
				width: 4.6rem;
				margin-bottom: .34rem;

				.module-box:nth-child(n+2) {
					margin-top: .24rem;
				}
			}
			
			&-main {
				position: relative;
			}
		}
		
		.foot {
			position: absolute;
			left: 50%;
			bottom: 0;
			height: 8px;
			transform: translate(-50%,0);
		}
	}
	
	.total {
		gap: .36rem;
		z-index: 1;
		position: relative;
		padding: .08rem 0 .4rem;
		
		&-item {
			gap: .16rem;
			position: relative;
			color: #00FFFF;
			
			p {
				font-size: .2rem;
			}
			
			ul {
				gap: .1rem;

				li {
					position: relative;
					width: .48rem;
					height: .55rem;
					background-image: linear-gradient(0deg, #034245, #00FFFF, #034245);
					font-size: .4rem;

					&:before {
						content: '';
						position: absolute;
						inset: 1px;
						background: #031115;
					}

					span {
						position: relative;
					}
				}
			}
		}
	}

	.tab {
		z-index: 1;
		position: relative;
		max-width: 8.7rem;
		height: .6rem;
		margin: 0 auto;
		background-size: auto 100%;
		background-repeat: no-repeat;

		&.z-tab-1 {
			background-image: url('~@/assets/image/digital/tab_1.png');
		}
		&.z-tab-2 {
			background-image: url('~@/assets/image/digital/tab_2.png');
		}

		li {
			width: 3.1rem;
			line-height: .6rem;
			font-size: .28rem;
			text-align: center;
			color: #00FFFF;
			cursor: pointer;
			transition: color .3s ease, text-shadow .3s ease;

			&.z-crt {
				color: #FFFC1A;
				text-shadow: 0 0 .15rem #FFFC1A;
			}
		}
	}

	.map {
		position: absolute;
		left: 50%;
		bottom: 0;
		width: 16.75rem;
		height: 8.55rem;
		max-width: 1600px;
		max-height: 816px;
		margin-left: .5rem;
		transform: translate(-50%,0);
		
		.item {
			z-index: 1;
			position: absolute;
			transform: translate(-50%,-50%);
			cursor: pointer;
			
			.light {
				content: '';
				position: absolute;
				left: 0;
				top: 0;
				width: .1rem;
				height: .1rem;
				border-radius: 50%;
				animation: pointLight 3s linear infinite;
			}
			
			.point {
				position: relative;
				width: .1rem;
				height: .1rem;
				border-radius: 50%;
				background: #fff;
			}
			
			.content {
				position: absolute;
				left: 50%;
				bottom: -.08rem;
				transform: translate(-50%,0)
				opacity: 0;
				transition: opacity .5s linear;
				pointer-events: none;
				
				&.z-active {
					opacity: 1;
					transition: opacity 2s linear;
					
					&:before {
						width: 0;
						animation: pointLine .5s linear;
						animation-delay: 1s;
						animation-fill-mode: forwards;
					}
				
					.icon {
						animation: pointIcon 2s ease;
						animation-fill-mode: forwards;
					}
					
					.data {
						opacity: 0;
						animation: pointData .5s linear;
						animation-delay: 1.5s;
						animation-fill-mode: forwards;
					}
				}
				
				&:before {
					content: '';
					position: absolute;
					right: .2rem;
					bottom: .4rem;
					width: .75rem;
					height: .6rem;
					background-image: url('~@/assets/image/digital/map_line.png');
					background-position: right center;
					background-size: .75rem .6rem;
				}
				
				.icon {
					position: relative;
					width: .4rem;
					max-width: none;
					max-height: none;
				}
				
				.data {
					position: absolute;
					right: .95rem;
					bottom: .4rem;
					box-sizing: border-box;
					width: 1.8rem;
					height: 1.02rem;
					padding: 0 .2rem;
					line-height: .28rem;
					font-size: .15rem;
					color: #FFDC1A;
					background-image: url('~@/assets/image/digital/map_content.png');
					background-size: 100% 100%;
					opacity: 1;

					h5 {
						font-size: .18rem;
						font-weight: normal;
						color: #fff;
					}
				}
			}
		}
	}

	@keyframes pointLight {
		0% {
			opacity: 1;
			box-shadow: 0 0 0 0 rgba(255,220,26,.6);
		}

		100% {
			opacity: 0;
			box-shadow: 0 0 .2rem .3rem rgba(255,220,26,.6);
		}
	}

	@keyframes pointIcon {
		0% {
			transform: translate(0,-.2rem);
		}

		100% {
			transform: translate(0,0);
		}
	}

	@keyframes pointLine {
		0% {
			width: 0;
		}

		100% {
			width: .75rem;
		}
	}

	@keyframes pointData {
		0% {
			opacity: 0;
		}

		100% {
			opacity: 1;
		}
	}
</style>
